import React from 'react';
import moment from 'moment';
import { getSort, getFilter } from '../Common/DataTable/tableHelpers';
import {
  EditButton,
  DuplicateButton,
} from '../Common/DataTable/tableActionButtons';

const createTableColumns = (onEdit, onDuplicate) => [
  {
    title: 'ID',
    name: 'id',
    hidden: true,
  },
  {
    title: 'Name',
    name: 'name',
  },
  {
    title: 'Description',
    name: 'description',
    hidden: true,
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 130,
    formatterComponent: ({ value }) => moment(value).format('DD/MM/YYYY'),
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(moment(value).format('DD/MM/YYYY'), filter.value),
    exportValue: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm:ss'),
  },
  {
    title: 'Action',
    name: 'action',
    width: 140,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        {onEdit && <EditButton row={row} onPress={onEdit} />}
        {onDuplicate && <DuplicateButton row={row} onPress={onDuplicate} />}
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
